"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("../");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * @props column(boolean), flex, flexWrap, justifyContent, alignItems, width, height, padding, margin, cursor,
 * backgroundColor, overflow, min-width, min-height, margin-right, margintop
 * @notes default media query: 768px - To change the device you need to extend the element
 */
var CardContainer = (0, _styledComponents.default)(_.FlexContainer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-bottom: 25px;\n    padding: 15px;\n    box-shadow: ", ";\n    background-color: ", ";\n    margin-top: ", ";\n    margin-right: ", ";\n    min-height: ", ";\n    min-width: ", ";\n    overflow: ", ";\n"])), function (props) {
  return props.theme.shadows.alert;
}, function (props) {
  return props.backgroundColor ? props.backgroundColor : props.theme.colors.white;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.marginRight;
}, function (props) {
  return props.minHeight;
}, function (props) {
  return props.minWidth;
}, function (props) {
  return props.overflow ? props.overflow : 'hidden';
});
var _default = CardContainer;
exports.default = _default;